import { render, staticRenderFns } from "./AccountPage.vue?vue&type=template&id=1d8c236c&scoped=true&"
import script from "./AccountPage.vue?vue&type=script&lang=js&"
export * from "./AccountPage.vue?vue&type=script&lang=js&"
import style0 from "./auth.css?vue&type=style&index=0&lang=css&"
import style1 from "./AccountPage.vue?vue&type=style&index=1&id=1d8c236c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8c236c",
  null
  
)

export default component.exports